import "./App.css";
import { BrowserRouter, Routes, Route, Link } from "react-router-dom";
import Home from "./pages/Home";
import PrivacyPolicy from "./pages/PrivacyPolicy";
import Support from "./pages/Support";

function App() {
  return (
    <BrowserRouter>
      <div className="site">
        <header className="site-header">
          <Link to="/" className="brand">
            <span className="brand-logo">E</span>
            <span className="brand-name">Echo Steps</span>
          </Link>
        </header>

        <main className="site-content">
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/privacy-policy" element={<PrivacyPolicy />} />
            <Route path="/support" element={<Support />} />
          </Routes>
        </main>

        <footer className="site-footer">
          <nav className="footer-nav">
            <Link to="/privacy-policy">Privacy Policy</Link>
            <span className="dot">•</span>
            <Link to="/support">Support</Link>
          </nav>
          <div className="copyright">
            © {new Date().getFullYear()} Echo Steps
          </div>
        </footer>
      </div>
    </BrowserRouter>
  );
}

export default App;
